/** Action types for POST notifications/email-events (server owns recipients/templates). */
export const EMAIL_EVENT_ACTIONS = {
  CART_ACCESS_BLOCKED: 'CartAccessBlocked',
} as const;

export type EmailEventActionType =
  (typeof EMAIL_EVENT_ACTIONS)[keyof typeof EMAIL_EVENT_ACTIONS];
